import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    return "Support Topela - Solution DEVIS - FACTURE"
}